// extracted by mini-css-extract-plugin
export default {"container":"blo_3RkXo","image":"blo_ima_doSfY","picture":"blo_pic_2HUlI","label":"blo_lab_nN64G","title":"blo_tit_1B3sh","price":"blo_pri_3NWvA","button":"blo_but_1-8hp"};